import styled from "styled-components";

// Modal関連のスタイル
export const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 1400;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  width: 90vw;
  max-width: 1200px;
  height: 90vh;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  position: relative;
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1e293b;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const ChangeWarningText = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  color: #d97706;
  font-size: 0.875rem;
  font-weight: 500;
  margin-right: 8px;
`;

// フォーム関連のスタイル
export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 10px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.3);
    border-radius: 3px;
    
    &:hover {
      background: rgba(148, 163, 184, 0.5);
    }
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: 10px;
  border-left: 1px solid #e2e8f0;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.3);
    border-radius: 3px;
    
    &:hover {
      background: rgba(148, 163, 184, 0.5);
    }
  }
  
  @media (max-width: 768px) {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #e2e8f0;
    padding-top: 20px;
    margin-top: 20px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
  font-size: 0.9rem;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.8rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  resize: vertical;
  min-height: 150px;
  line-height: 1.4;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

// 参照モード用のスタイル
export const ViewValue = styled.div`
  width: 100%;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #1f2937;
  white-space: pre-wrap;
  min-height: 40px;
  border: 1px solid #e2e8f0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
`;

export const ViewStepItem = styled.div`
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
`;

export const ViewStepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ViewStepNumber = styled.div`
  background: #667eea;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
`;

export const ViewStepContent = styled.div`
  color: #4b5563;
  font-size: 0.9rem;
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  align-items: center;
`;

export const ViewStepField = styled.div`
  font-size: 0.85rem;
  
  strong {
    color: #374151;
    font-weight: 500;
    display: block;
    margin-bottom: 2px;
  }
`;

export const StepsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 300px;
`;

export const StepsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StepsTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
`;

export const AddStepButton = styled.button`
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: #667eea;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background: #5a67d8;
  }
`;

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  position: relative;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.3);
    border-radius: 2px;
  }
`;

export const DropZone = styled.div<{ $isActive?: boolean; $isFirst?: boolean }>`
  height: ${(props) => (props.$isFirst ? "12px" : "8px")};
  min-height: ${(props) => (props.$isFirst ? "12px" : "8px")};
  margin: ${(props) => (props.$isFirst ? "0 0 4px 0" : "4px 0")};
  position: relative;
  transition: all 0.2s ease;
  z-index: ${(props) => (props.$isActive ? 10 : 1)};
  
  ${(props) =>
    props.$isActive &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #667eea 0%, #5a67d8 100%);
      border-radius: 2px;
      box-shadow: 0 0 8px rgba(102, 126, 234, 0.6), 0 2px 4px rgba(102, 126, 234, 0.4);
      animation: pulse 1s ease-in-out infinite;
    }
    
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.8;
      }
    }
  `}
`;

export const StepItem = styled.div<{ $isDragging?: boolean }>`
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  background: ${(props) => (props.$isDragging ? "#f1f5f9" : "#f8fafc")};
  display: flex;
  gap: 6px;
  cursor: default;
  opacity: ${(props) => (props.$isDragging ? 0.3 : 1)};
  transition: all 0.2s ease;
  position: relative;
  transform: ${(props) => (props.$isDragging ? "scale(0.98)" : "scale(1)")};
  align-items: flex-start;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  color: #9ca3af;
  cursor: grab;
  flex-shrink: 0;
  
  &:active {
    cursor: grabbing;
  }
  
  &:hover {
    color: #64748b;
  }
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
`;

export const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  background: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const StepActions = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
`;

export const IconButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #e2e8f0;
    color: #1e293b;
  }
  
  &.delete:hover {
    background: #fef2f2;
    color: #ef4444;
  }
`;

export const StepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.85rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  min-height: 32px;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
  }
  
  &::placeholder {
    color: #9ca3af;
    font-size: 0.85rem;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;
`;

export const SelectButton = styled.button`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  background: white;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 36px;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
  }
  
  &:hover {
    border-color: #9ca3af;
  }
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    margin-right: 4px;
  }
`;

export const SelectDropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  z-index: 1;
  max-height: 200px;
  overflow-y: auto;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  margin-top: 2px;
`;

export const SelectOption = styled.div<{ $isSelected: boolean }>`
  padding: 8px 10px;
  font-size: 0.9rem;
  cursor: pointer;
  background: ${(props) => (props.$isSelected ? "#f3f4f6" : "white")};
  
  &:hover {
    background: #f3f4f6;
  }
  
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Button = styled.button<{ variant?: "primary" | "secondary" | "danger" }>`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  ${(props) => {
    switch (props.variant) {
      case "primary":
        return `
          background: #667eea;
          color: white;
          &:hover {
            background: #5a67d8;
          }
        `;
      case "danger":
        return `
          background: #ef4444;
          color: white;
          &:hover {
            background: #dc2626;
          }
        `;
      default:
        return `
          background: #f1f5f9;
          color: #475569;
          &:hover {
            background: #e2e8f0;
          }
        `;
    }
  }}
`;

// ステータスバッジ
export const StatusBadge = styled.span<{ status: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  gap: 4px;

  ${(props) => {
    switch (props.status) {
      case "draft":
        return `
          background: #f3f4f6;
          color: #6b7280;
        `;
      case "need_review":
        return `
          background: #fef3c7;
          color: #d97706;
          border: 1px solid #fbbf24;
        `;
      case "in_review":
        return `
          background: #dbeafe;
          color: #2563eb;
          border: 1px solid #60a5fa;
        `;
      case "approved":
        return `
          background: #d1fae5;
          color: #059669;
          border: 1px solid #34d399;
        `;
      case "rejected":
        return `
          background: #fee2e2;
          color: #dc2626;
          border: 1px solid #f87171;
        `;
      case "archived":
        return `
          background: #e5e7eb;
          color: #4b5563;
        `;
      default:
        return `
          background: #f3f4f6;
          color: #6b7280;
        `;
    }
  }}
`;

// Tab navigation styles
export const TabContainer = styled.div`
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0 20px;
`;

export const TabList = styled.div`
  display: flex;
  gap: 0;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  padding: 12px 20px;
  border: none;
  background: ${(props) => (props.$isActive ? "white" : "transparent")};
  color: ${(props) => (props.$isActive ? "#1e293b" : "#64748b")};
  font-size: 0.9rem;
  font-weight: ${(props) => (props.$isActive ? "600" : "500")};
  cursor: pointer;
  border-bottom: 2px solid ${(props) =>
    props.$isActive ? "#667eea" : "transparent"};
  transition: all 0.2s ease;
  position: relative;
  top: 1px;

  &:hover {
    color: #1e293b;
    background: ${(props) => (props.$isActive ? "white" : "#f1f5f9")};
  }
`;

export const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
`;

// 不正なターゲット,ターゲット未設定タグ
export const InvalidTargetBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.65rem;
  font-weight: 500;
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #f87171;
  white-space: nowrap;
  gap: 4px;
`;

export const TargetWarningText = styled.div`
  margin-top: 4px;
  color: rgb(220, 38, 38);
  font-weight: 700;
`;